import { AxisInterval } from 'recharts/types/util/types';

export const getXAxisTickInterval = (
  dataLength: number,
  isSmallSize: boolean,
  tickCount?: number,
): AxisInterval => {
  if (tickCount) {
    return Math.floor(dataLength / tickCount);
  }
  if (dataLength > 14 || isSmallSize) {
    return 'preserveStartEnd';
  }
  return 0;
};
